import { config, EditablePage, ProvideAll } from '@ds-mgnl/marketing';
import { useLoaderData } from 'react-router-dom';
import type { LoaderFunction } from 'react-router-dom';
import { getMagnoliaBaseUrl } from '../util';

export const magnoliaPageLoader: LoaderFunction = async ({ request }) => {
	const currentPageUrl = new URL(request.url);
	const magnoliaBaseUrl = getMagnoliaBaseUrl();
	const fullContentPath = new URL(
		`${magnoliaBaseUrl}${process.env.MGNL_API_PAGES!}${
			process.env.MGNL_PAGES_APP_BASE
		}${currentPageUrl.pathname}`
	);

	// Add the x-mgnl-tels-referral-traits request paramater to the API request.
	// Enables personalization using the 'requestParameterTrait' trait type. https://docs.magnolia-cms.com/product-docs/6.3/developing/headless/spa-development/personalization-of-headless-spa-projects/#_configure_one_or_more_traits
	const searchParams = currentPageUrl.searchParams;
	const hasReferralParam = searchParams.has('referral');
	if (hasReferralParam) {
		const telsReferralHeader = searchParams.get('referral');
		if (telsReferralHeader) {
			fullContentPath.searchParams.set(
				'x-mgnl-tels-referral-traits',
				telsReferralHeader
			);
		}
	}

	const pageResponse = await fetch(fullContentPath);
	if (pageResponse.status != 200) {
		throw new Error(pageResponse.statusText);
	}
	const pageJson = await pageResponse.json();
	return { pageJson };
};

export function MagnoliaPage() {
	const { pageJson } = useLoaderData() as any;

	return (
		<ProvideAll>
			<EditablePage
				templateAnnotations={{}}
				content={pageJson}
				config={config}
			></EditablePage>
		</ProvideAll>
	);
}
